import React, { useState } from "react";

import moment from "moment";
import 'moment/locale/pt-br'

import {
    Card,
    CardContent,
    Typography,
    Grid,
    Hidden,
    CardActionArea,
    Divider,
    Snackbar,
    Button,
    Tooltip,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import * as MaterialIcons from "@material-ui/icons";

import datetimeProvider from "../../providers/datetime.provider";

const NotificationList = (props) => {

    const [statusMsg, setStatusMsg] = useState({});

    const read = async (id, link) => {
        await markAsRead(id)
        link && window.open(link, '_blank')
    }

    const markAsRead = async (id) =>
        await props.onRead(id)
            .catch(() => setAlertStatus('Notificação não encontrada.', 'warning'))

    const setAlertStatus = (msg, severity) =>
        setStatusMsg({ text: msg, date: new Date(), open: true, severity });

    const handleCloseAlert = () =>
        setStatusMsg({ text: "", date: new Date(), open: false });

    const notificationItem = (notification, index) => {

        const layoutInfo = notification?.additionalData?.layoutInfo || {};
        const IconComponent = MaterialIcons[layoutInfo.materialIcon] || MaterialIcons.LibraryBooks;

        return <>
            <CardActionArea key={index}>
                <Card mb={4}>
                    <CardContent style={{ cursor: 'pointer', padding: "25px 20px 20px" }}>
                        <Grid container direction="row" alignItems="center" onClick={() => read(notification.id, notification.additionalData.link || false)}>
                            <Hidden only={['xs', 'sm']}>
                                <Grid item>
                                    <div
                                        className={`flex items-center justify-center rounded-full bg-${layoutInfo.tailwindColor || 'blue'}-600 text-white w-5 h-5 mr-2`}
                                        aria-label={notification.title}
                                    >
                                        <IconComponent style={{ fontSize: '13px' }} />
                                    </div>
                                </Grid>
                            </Hidden>
                            <Grid item xs>
                                <Typography variant="body1" style={{ whiteSpace: "pre-wrap", fontWeight: "500", fontSize: '16px' }} >
                                    {`${notification.title}`}
                                </Typography>
                            </Grid>
                        </Grid>
                        <div style={{ display: 'flex' }} onClick={() => read(notification.id, notification.additionalData.link || false)}>
                            <p style={{
                                fontSize: "11px", marginTop: "10px", lineHeight: '1.4',
                                whiteSpace: 'pre-wrap', overflow: "hidden", textOverflow: "ellipsis"
                            }}>
                                <span style={{ marginBottom: "-3px", paddingTop: "3px", marginRight: "2px", fontSize: '12px' }}>{notification.description}</span>
                            </p>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px' }}>
                            <Tooltip title={datetimeProvider.formatDateTime(notification.createdAt, undefined, true)}>
                                <span style={{ fontSize: '12px', fontWeight: '400' }} className="text-gray-500">
                                    {moment(notification.createdAt).locale('pt-BR').fromNow()}
                                </span>
                            </Tooltip>
                            <Button
                                aria-label="Marcar lida"
                                size="small"
                                color="default"
                                variant="outlined"
                                style={{ padding: '2px 6px', fontSize: '11px', borderRadius: '12px', opacity: 0.8 }}
                                onClick={async () => await markAsRead(notification.id)}
                            >
                                <MaterialIcons.DraftsOutlined style={{ fontSize: 16, marginRight: 4 }} />
                                Marcar como lida
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </CardActionArea>
            <Divider />
        </>
    }

    return (
        <div style={{
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            maxWidth: '400px'
        }}>
            <div style={{
                borderBottom: '2px solid #376FD0',
                textAlign: 'center',
                marginTop: '-10px',
                padding: '8px 0',
                backgroundColor: '#f5f5f5',
                borderRadius: '4px 4px 0 0'
            }}>
                <p style={{
                    color: '#376FD0',
                    fontSize: '16px',
                    fontWeight: '600',
                    margin: 0,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>Notificações</p>
            </div>
            <div style={{ backgroundColor: '#f5f5f5', }}>
                {props.notifications.map(notificationItem)}
            </div>

            <Snackbar onClose={handleCloseAlert} open={statusMsg.open}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={2000} key={statusMsg.date}>
                <Alert severity={statusMsg.severity}>
                    {statusMsg.text}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default NotificationList;
